import { resolveSectionJumpHref } from './sectionAnchors';

export type ButtonActionMode = 'simple' | 'advanced';
export type ButtonActionKind = 'navigation' | 'section-jump' | 'model-preview';

export interface NormalizedButtonAction {
  mode: ButtonActionMode;
  kind: ButtonActionKind;
  href: string;
  advancedHref: string;
  pageKey: string;
  sectionId: string;
  modelPath: string;
  vaseId?: number;
}

export function resolvePageHref(pageKey: string): string {
  if (pageKey === 'intro') return '/';
  if (pageKey === 'home') return '/home';
  return `/${pageKey}`;
}

export function normalizeButtonActionContent(
  content: Record<string, unknown> | null | undefined
): NormalizedButtonAction {
  const mode: ButtonActionMode =
    content?.actionMode === 'simple' || content?.actionMode === 'advanced'
      ? content.actionMode
      : 'advanced';
  const kind: ButtonActionKind =
    content?.actionKind === 'model-preview'
      ? 'model-preview'
      : content?.actionKind === 'section-jump'
        ? 'section-jump'
        : 'navigation';
  const href = typeof content?.href === 'string' && content.href.trim().length > 0 ? content.href.trim() : '#';
  const advancedHref =
    typeof content?.advancedHref === 'string' && content.advancedHref.trim().length > 0
      ? content.advancedHref.trim()
      : '';
  const pageKey =
    typeof content?.pageKey === 'string' && content.pageKey.trim().length > 0
      ? content.pageKey.trim()
      : 'home';
  const sectionId =
    typeof content?.sectionId === 'string' && content.sectionId.trim().length > 0
      ? content.sectionId.trim()
      : '';
  const modelPath =
    typeof content?.modelPath === 'string' && content.modelPath.trim().length > 0
      ? content.modelPath.trim()
      : '';
  const vaseId = Number.isFinite(content?.vaseId) && Number(content?.vaseId) > 0 ? Number(content?.vaseId) : undefined;

  return {
    mode,
    kind,
    href,
    advancedHref,
    pageKey,
    sectionId,
    modelPath,
    vaseId,
  };
}

export function resolveButtonHref(content: Record<string, unknown> | null | undefined): string {
  const action = normalizeButtonActionContent(content);
  if (action.mode === 'advanced') {
    return action.advancedHref || action.href || '#';
  }
  if (action.kind === 'navigation') {
    return action.href || resolvePageHref(action.pageKey);
  }
  if (action.kind === 'section-jump') {
    return resolveSectionJumpHref(action.sectionId);
  }
  return '#';
}

export function isModelPreviewButtonAction(content: Record<string, unknown> | null | undefined): boolean {
  const action = normalizeButtonActionContent(content);
  return action.mode === 'simple' && action.kind === 'model-preview' && action.modelPath.length > 0;
}
